import {Backdrop, BoxProps, LinearProgress, styled} from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import Logo from 'src/components/common/Logo';
import Typography from '@mui/material/Typography';

const ImageContainer = styled(Box)<BoxProps>(({theme}) => ({
    '&.MuiBox-root': {
        background: theme.palette.secondary.main,
        height: '64px',
        color: '#fff',
        borderRadius: '10px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));


const StyledImage = styled(Logo)(() => ({
    width: '150px'
}));


const ModuleFallBack: React.FC = () => {

    return (<Backdrop
        sx={{zIndex: 3500, backgroundColor: 'secondary.100'}}
        open={true}>
        <Box sx={{textAlign: 'center'}}>
            <ImageContainer sx={{mb:2}}>
                <StyledImage/>
                <Box>
                    <Typography variant="caption">CGC</Typography>
                </Box>
            </ImageContainer>

            <LinearProgress sx={{
                height: '8px',
                width: '100%',
                borderRadius: '8px'
            }} variant="indeterminate" color="secondary" />
        </Box>
    </Backdrop>)
}

export default ModuleFallBack